import { useCallback, useState } from 'react';
import { JSONbigParse, JSONbigStringify } from 'app/home/general-components/JsonBig';

import log from 'app/home/general-components/Logging';

export default function useLocalStorage(key, initialValue, oldKey = undefined) {
    const [storedValue, setStoredValue] = useState(() => {
        try {
            const item = window.localStorage.getItem(key);
            // console.log("useLocalStorage", key, item);
            if (item) {
                if (item === "undefined")
                    return undefined;
                return JSONbigParse(item);
            }
            // key is not existed so far
            if (oldKey !== undefined) {
                const oldItem = window.localStorage.getItem(oldKey);
                if (oldItem) {
                    window.localStorage.setItem(key, oldItem); // set new key
                    if (oldItem === "undefined")
                        return undefined;
                    return JSONbigParse(oldItem);
                }
            }
            // key and oldKey is not existed so far
            window.localStorage.setItem(key, JSONbigStringify(initialValue));
            return initialValue;
        } catch (error) {
            log(error);
            return undefined;
        }
    });

    const setValue = useCallback((value) => {
        // // Allow value to be a function so we have same API as useState
        // const valueToStore =
        //     value instanceof Function ? value(storedValue) : value;

        setStoredValue(value);
        window.localStorage.setItem(key, JSONbigStringify(value));
    }, [key]);

    return [storedValue, setValue];
}